module.exports = __webpack_public_path__ + "static/media/DSC01852.4fe3a5b0.jpeg";